<template>
  <section
    class="main landing-page-content"
    :style="getGradient"
  >
    <sign-in-button class="signin-button" />
    <div class="center-bkgrnd" />
    <landing-hero-banner
      class="hero-banner landing-page d-flex"
      :servicer="servicer"
    >
      <servicer-wrapper
        :servicer="servicerProfile"
        :partner="partnerProfile"
      />
    </landing-hero-banner>
    <go-mobile-wrapper
      v-if="$vuetify.breakpoint.lgAndUp && showMobileContent"
      class="go-mobile-wrapper d-flex"
      :servicer="servicerProfile"
    />
    <footer-wrapper
      :dark-theme="true"
      :servicer="servicerProfile"
      :sac="sac"
    />
  </section>
</template>

<script>
import SignInButton from './Header/SignInButton.vue'
import LandingHeroBanner from './HeroBanner/LandingHeroBanner.vue'
import ServicerWrapper from './Servicer/ServicerWrapper.vue'
import GoMobileWrapper from './GoMobile/GoMobileWrapper.vue'
import FooterWrapper from './Footer/FooterWrapper.vue'

import { NullServicer, NullPartner } from './Servicer/nullProfile'
import { rgbaFromHexAndOpacity } from '~/assets/javascript/utilityFunctions.js'
import shareBySmsMixin from '../../common/shareBySmsMixin'
import snThemeMixin from '~/components/common/snThemeMixin'
import fetchServicerMixin from '../Onboarding/Shared/fetchServicerMixin.js'

export default {
  name: 'LandingPage',
  components: {
    SignInButton,
    LandingHeroBanner,
    ServicerWrapper,
    GoMobileWrapper,
    FooterWrapper
  },
  mixins: [shareBySmsMixin, snThemeMixin, fetchServicerMixin],
  data () {
    return {
      partner: new NullPartner(),
      servicer: new NullServicer()
    }
  },
  computed: {
    servicerProfile () {
      return this.servicer
    },
    partnerProfile () {
      return this.partner
    },
    themeColor () {
      return this.$vuetify.theme.themes.light.primary
    },
    profileColorLight () {
      return rgbaFromHexAndOpacity(this.themeColor, 0.5)
    },
    profileColorDark () {
      return rgbaFromHexAndOpacity(this.themeColor, 1.0)
    },
    sac () {
      return this.$route.params.code
    },
    getGradient () {
      return `background: linear-gradient(90deg, ${this.profileColorDark} 0.68%, ${this.profileColorLight} 51.8%, ${this.profileColorDark} 100%);`
    },
    showMobileContent () {
      return this.servicer.borrower_web_content_setting_show_mobile_content_on_landing_page
    }
  },
  beforeCreate () {
    // used by snThemeMixin to fetch custom themes
    this.$store.activationCode = this.$route.params.code
  },
  methods: {
    rgbaFromHexAndOpacity
  }
}
</script>

<style scoped lang="scss">
  @import "~/assets/css/snui";

  .signin-button {
    position: absolute;
    top: 32px;
    right: 32px;
  }
  .main {
    height: 100%;
    padding-top: 360px;
  }
  .center-bkgrnd {
    position: absolute;
    bottom: 0;
    background: $sn-gray-01;
    height: calc(100% - 360px);
    width: 100%;
  }
  .hero-banner {
    position: relative;
    margin-top: -200px;
    max-width: 1184px;
  }
  .go-mobile-wrapper {
    margin-top: 76px;
    max-width: 1184px;
  }
  .watermark {
    position: relative;
    margin-bottom: 8px;
    padding-bottom: 30px;
    background-color: $sn-white;
  }

  .landing-page-content {
    height: 100%;
    flex-direction: column;
    display: flex;
  }
  .landing-page {
    flex-grow: 1;
    display: flex;
  }

  @media screen and (min-width: 991px) and (max-width: 1184px) {
    .hero-banner {
      max-width: 950px;
    }
  }

  @media screen and (max-width: $medium-screen-size) {
    .watermark {
      background-color: initial;
    }
  }
</style>
